import { render, staticRenderFns } from "./BlackPearlShop.vue?vue&type=template&id=0fae9c6e&"
import script from "./BlackPearlShop.vue?vue&type=script&lang=ts&"
export * from "./BlackPearlShop.vue?vue&type=script&lang=ts&"
import style0 from "./BlackPearlShop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports